export const BRAND_LOGO = "https://img.vicevalleyroleplay.com/img/n06khfJd0B683-6KpPMeKmeK";
export const BRAND_NAME = "Vice Valley Roleplay";
export const BRAND_HUB = "Human Resources";
